module.exports = __webpack_public_path__ + "img/vaquinhas.0e54bfbb.jpg";